<template>
  <v-app id="app">
    <v-main>
      <v-container fluid id="home-container">
        <Header></Header>
        <Main></Main>
        <Statistics></Statistics>
        <hr style="width:100%;opacity: 0.2"/>
        <Footer></Footer>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import Main from './components/Main'
import Statistics from './components/Statistics'

export default {
  name: 'App',
  components: {
    Header,
    Footer,
    Main,
    Statistics
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@300;400&display=swap');

#app {
  font-family: 'Noto Sans KR', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0;

  #home-container {
    min-width: 320px;
    padding: 0;
    margin: 0;
  }
}
</style>
